import { useLazyGetCarEnginesQuery } from '@/api/carEngines'
import FilterableSelect from '@/components/inputs/FilterableSelect/FilterableSelect'
import { useTranslation } from 'next-i18next'
import React from 'react'

type Props = {
  carModel?: number
  selectedEngine: number | undefined
  onSelectedEngine: (value: number) => void
}

const CarEngines = (props: Props) => {
  const [trigger, result] = useLazyGetCarEnginesQuery()
  const { t } = useTranslation('shop')

  const onSelectedEngine = (value: string | null) => {
    props.onSelectedEngine(Number(value))
  }

  React.useEffect(() => {
    if (props.carModel)
      trigger(props.carModel)
  }, [props.carModel, trigger])

  const engines = result.data?.map((engine) => {
    return {
      name: engine.name,
      value: engine.kTypeId
    }
  })

  return (
    <FilterableSelect
      options={engines || []}
      name="engine"
      placeholder={t('carEngine') || ''}
      value={props.selectedEngine ? props.selectedEngine.toString() : null}
      onChange={onSelectedEngine}
      loading={result.isFetching}
      disabled={!props.carModel || !engines?.length}
    />
  )
}

export default CarEngines